module.exports = __webpack_public_path__ + "img/吉田航大.857dc5dd.jpg";